(() => {
  if (window.__coastaSupportLivePositioning) return;
  window.__coastaSupportLivePositioning = true;

  const root = document.documentElement;
  let raf = 0;

  const getHeader = () => document.querySelector('.header-section .header');
  const hasSupport = () => Boolean(document.querySelector('.coasta-support-details'));
  const isSupportOpen = () => Boolean(document.querySelector('.coasta-support-details[open]'));

  const measure = () => {
    raf = 0;
    const header = getHeader();
    if (!header || !hasSupport()) return;

    const rect = header.getBoundingClientRect();
    // Fixed mega-menu positioning needs the actual viewport bottom of the
    // rendered header, not Concept's cached --header-height value.
    const top = Math.max(0, Math.round(rect.bottom));
    const available = Math.max(240, Math.round(window.innerHeight - top));

    root.style.setProperty('--coasta-support-top', `${top}px`);
    root.style.setProperty('--coasta-support-max-height', `${available}px`);
  };

  const scheduleMeasure = () => {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(measure);
  };

  // Calculate before hover/click opens the native Concept details element,
  // then re-measure on toggle after its sticky-header state has settled.
  document.addEventListener('pointerover', (event) => {
    if (event.target.closest?.('.coasta-support-details')) scheduleMeasure();
  }, { passive: true });

  document.addEventListener('pointerdown', (event) => {
    if (event.target.closest?.('.coasta-support-details')) scheduleMeasure();
  }, { passive: true });

  document.addEventListener('toggle', (event) => {
    if (event.target.matches?.('.coasta-support-details')) {
      scheduleMeasure();
      requestAnimationFrame(scheduleMeasure);
    }
  }, true);

  document.addEventListener('header:scrolled', scheduleMeasure);
  window.addEventListener('resize', scheduleMeasure, { passive: true });
  window.addEventListener('scroll', () => {
    if (isSupportOpen()) scheduleMeasure();
  }, { passive: true });

  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(scheduleMeasure);
    const observeHeader = () => {
      const header = getHeader();
      if (header) observer.observe(header);
    };
    observeHeader();
    document.addEventListener('shopify:section:load', observeHeader);
  }

  scheduleMeasure();
})();
